import svegileLogo from "../../../assets/img/svegile/logo.png";
import {
  CpuChipIcon,
  UsersIcon,
  ArrowPathRoundedSquareIcon,
  DocumentMagnifyingGlassIcon,
  BuildingOfficeIcon,
  DevicePhoneMobileIcon,
  GlobeAltIcon,
  ComputerDesktopIcon
} from "@heroicons/react/24/solid";

const services = "/services";

const FocusAreas = {
  text: "Focus Areas",
  href: services,
  items: [
    {
      items: [
        { to: "/services/software-development", children: "Software Development", icon:  ComputerDesktopIcon},
        { to: "/services/web-development", children: "Web Development", icon:  GlobeAltIcon },
        { to: "/services/mobile-development", children: "Mobile Development", icon:  DevicePhoneMobileIcon },
        { to: "/services/enterprise-development", children: "Enterprise Operations", icon:  BuildingOfficeIcon },
        { to: "/services/quality-assurance", children: "Quality Assurance", icon:  DocumentMagnifyingGlassIcon },
        { to: "/services/devops-cloud", children: "DevOps and Cloud Engineering", icon:  ArrowPathRoundedSquareIcon },
        { to: "/services/dedicated-dev-team", children: "Dedicated Development Team", icon:  UsersIcon },
        { to: "/services/startup-development", children: "Startup Development", icon:  CpuChipIcon },
      ],
    },
  ],
};

const DiscoverPage = "/discover";
const Discover = {
  text: "Discover",
  href: DiscoverPage,
  items: [
    {
      items: [
        { to: DiscoverPage, children: "Engagement" },
        { to: DiscoverPage, children: "Technology" },
      ],
    },
  ],
};

const Resource =  "/resources";

// const Resources = {
//   text: "Resources",
//   items: [
//     {
//       items: [
//         { to: Resource, children: "Success stories" },
//         { to: "/insights", children: "Insights" },
//       ],
//     },
//   ],
// };

const textProps = {
  color: "white",
  type: "fixed",
  logoImage: svegileLogo,
  logoText: "Svegile Technologies",
  logoLink: {
    to: "/home",
  },
  rightLinks: [
    {
      dropdown: true,
      href: services,
      ...FocusAreas,
    },
    // {
    //   dropdown: true,
    //   href: DiscoverPage,
    //   ...Discover,
    // },
    // {
    //   dropdown: true,
    //   ...Resources
    // },
    {
      href: "resources",
      children: "Success stories",
    },
    // {
    //   href: "/insights",
    //   children: "Insights",
    // },
    {
      href: "careers",
      children: "Careers",
    },
    {
      href: "aboutUs",
      children: "About Us",
    },
  ],
};
export default textProps;
